import { api } from '@/lib/api';
import type { IApiResponse } from '@skystone/shared';

type QueryValue = string | boolean | number | undefined;
type QueryEntry = readonly [string, QueryValue];

export function buildListEndpoint(path: string, entries: ReadonlyArray<QueryEntry>): string {
  const params = new URLSearchParams();

  for (const [key, value] of entries) {
    if (value === undefined) {
      continue;
    }

    params.set(key, String(value));
  }

  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

const PAGE_SIZE = 500;
const MAX_PAGES = 20;

export async function fetchAllPaginated<T>(
  path: string,
  entries: ReadonlyArray<QueryEntry>,
): Promise<T[]> {
  const allRows: T[] = [];

  for (let page = 0; page < MAX_PAGES; page += 1) {
    const url = buildListEndpoint(path, [
      ...entries,
      ['limit', PAGE_SIZE],
      ['offset', page * PAGE_SIZE],
    ]);
    const result = await api.get<IApiResponse<T[]>>(url);
    const rows = result.data;
    allRows.push(...rows);

    if (rows.length < PAGE_SIZE) break;
  }

  return allRows;
}
